<div class="container">
  <div class="title">
    <mat-icon svgIcon="info-icon" class="info-icon"></mat-icon>
    <div class="title-text" [innerHTML]="data.title"></div>
    <app-modal-close-button
      class="close-button"
      [closeDialog]="closeDialog.bind(this)"></app-modal-close-button>
  </div>
  <div class="message" [innerHTML]="data.message"></div>
  <div class="buttons">
    <button class="button" (click)="closeDialog()">OK, verstanden</button>
  </div>
</div>
